import { render } from "./Logging.vue?vue&type=template&id=dd43a690&ts=true"
import script from "./Logging.vue?vue&type=script&lang=ts"
export * from "./Logging.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__